/**
 * Utility functions for environment detection
 */

/**
 * Checks if the application is running in a development environment (localhost)
 * @returns {boolean} - True if running on localhost, false otherwise
 */
export const isLocalEnvironment = () => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || 
         hostname === '127.0.0.1' || 
         hostname.includes('192.168.') ||
         hostname.includes('10.0.') ||
         hostname.startsWith('172.16.') ||
         hostname.startsWith('172.17.') ||
         hostname.startsWith('172.18.') ||
         hostname.startsWith('172.19.') ||
         hostname.startsWith('172.20.') ||
         hostname.startsWith('172.21.') ||
         hostname.startsWith('172.22.') ||
         hostname.startsWith('172.23.') ||
         hostname.startsWith('172.24.') ||
         hostname.startsWith('172.25.') ||
         hostname.startsWith('172.26.') ||
         hostname.startsWith('172.27.') ||
         hostname.startsWith('172.28.') ||
         hostname.startsWith('172.29.') ||
         hostname.startsWith('172.30.') ||
         hostname.startsWith('172.31.');
};

/**
 * Checks if the application is running on the production domain
 * @returns {boolean} - True if running on production domain, false otherwise
 */
export const isProductionEnvironment = () => {
  const hostname = window.location.hostname;
  return hostname.includes('rakdigital.net');
}; 